// extracted by mini-css-extract-plugin
export default {"label":"ComicDetail_label__CknHv","person":"ComicDetail_person__iBMQf"};